/* =========================================================
   LITANY TOYS — theme script
   Hooks into Dawn's existing systems rather than replacing
   them: cart badge reads Dawn's own PUB_SUB_EVENTS.cartUpdate
   (assets/pubsub.js + constants.js, loaded earlier as classic
   scripts), and the mobile nav forwards to Dawn's real menu
   drawer / cart drawer triggers instead of reimplementing them.
   ========================================================= */

(function () {
  'use strict';

  function initCartBadgeSync() {
    var badge = document.getElementById('litany-mobile-nav-cart-badge');
    if (!badge) return;

    function setCount(count) {
      badge.textContent = count;
      if (count > 0) {
        badge.removeAttribute('hidden');
      } else {
        badge.setAttribute('hidden', '');
      }
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (res) {
            return res.json();
          })
          .then(function (cart) {
            setCount(cart.item_count);
          })
          .catch(function () {
            /* fail silently — badge simply keeps its last known count */
          });
      });
    }
  }

  function initMobileNavActions() {
    // "Categories" opens Dawn's existing mobile menu drawer rather than
    // a second, separate drawer implementation.
    var menuButton = document.getElementById('litany-mobile-nav-menu');
    if (menuButton) {
      menuButton.addEventListener('click', function () {
        var summary = document.querySelector('#Details-menu-drawer-container summary');
        if (summary) {
          summary.click();
        } else {
          window.location.href = '/collections/all';
        }
      });
    }

    // "Cart" forwards its click to Dawn's real header cart icon so the
    // existing cart-drawer JS opens it. Falls back to a normal link to
    // the cart page if that icon isn't found for any reason.
    var cartLink = document.getElementById('litany-mobile-nav-cart');
    if (cartLink) {
      cartLink.addEventListener('click', function (event) {
        var realCartLink = document.getElementById('cart-icon-bubble');
        if (realCartLink) {
          event.preventDefault();
          realCartLink.click();
        }
      });
    }
  }

  function initMobileNavActiveState() {
    var items = document.querySelectorAll('.litany-mobile-nav__item[href]');
    var currentPath = window.location.pathname.replace(/\/$/, '') || '/';

    items.forEach(function (item) {
      var itemPath = item.pathname.replace(/\/$/, '') || '/';
      if (itemPath === currentPath) {
        item.classList.add('is-active');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCartBadgeSync();
    initMobileNavActions();
    initMobileNavActiveState();
  });
})();
